import React from "react";
import { SvgSpinner } from "@/assets/icons";
import styled, { keyframes } from "styled-components";

export const LoadingSpin = ({ size = 28 }) => {
	return (
		<Container>
			<SvgSpinner width={size} height={size} />
		</Container>
	);
};

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: fit-content;
	animation: ${spin} 0.8s linear infinite;
`;
